<mat-sidenav-container class="products-container">
    <mat-sidenav #sidenav [opened]="sidenavOpen" [mode]="sidenavMode" perfectScrollbar class="filter-sidenav"
        *ngIf="sharedDataService.themeType === 'Default'">

        <mat-accordion displayMode="flat" multi="true">
            <mat-expansion-panel expanded>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <h4>Categories</h4>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="categories-wrapper categories-dropdown" perfectScrollbar>
                    <app-category-list [categories]="categories" [categoryParentId]="0"
                        (change)="onChangeCategory($event)"></app-category-list>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel expanded>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <h4>Vendors</h4>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div fxLayout="row wrap" fxLayoutAlign="start center" class="filter-brands">
                    <button mat-raised-button *ngFor="let brand of brands" (click)="brandSelection(brand)"
                        [class.selected]="brand.selected">
                        <a class="imgStyle clr-blu">
                            <img *ngIf="!!brand['vendor_logo']" src="data:," [imgName]="brand['vendor_logo']"
                                imgType="vendors" alt="{{brand['vendor_name']}}" class="img-wd" imagePreload />
                            <span *ngIf="!!!brand['vendor_logo']">{{brand['vendor_name']}}</span>
                        </a>
                    </button>
                </div>
            </mat-expansion-panel>

        </mat-accordion>

    </mat-sidenav>
    <mat-sidenav-content class="all-products" ngClass.gt-sm="p-left"
        *ngIf="router.url !== '/categories' && router.url !== '/shop' ">

        <div *ngIf="categoryName">
            <div fxLayout="column">
                <div fxLayout="row" fxLayoutGap="5px">
                    <!-- if category name is not empty then show this button -->
                    <button *ngIf="!sidenavOpen" mat-icon-button (click)="sidenav.toggle()">
                        <i class="material-icons " data-icon="more_vert"></i>
                    </button>
                    <!-- end -->
                    <h1 [innerHTML]="categoryName | sanitizeHtml" class="clr-red"> </h1>
                </div>
                <div *ngIf="page === 1 && categoryDescription !== '' && categoryDescription !== null && 
                    categoryDescription !== undefined" [innerHTML]="categoryDescription | sanitizeHtml" id="img-res">
                </div>
                <div *ngIf="categoryDescription !== '' && categoryDescription !== null && 
                    categoryDescription !== undefined" [innerHTML]="categoryDescription | sanitizeHtml" id="img-res">
                </div>
            </div>
        </div>
        <ng-container *ngIf="!!featureTags && featureTags['sf_vendor_page']">
            <div fxLayout="row wrap" *ngIf="!!supplier_info['vendor_name'] && !pageLoaded">
                <div fxFlex="100" fxFlex.gt-xs="20" class="Vendor_Info p-2">
                    <img *ngIf="!!supplier_info['vendor_logo']"  class="img-responsive" src="data:," [imgName]="supplier_info['vendor_logo']" 
                        alt = "{{supplier_info['vendor_name']}}" imgType="vendors" imgSize="md" imagePreload >
                    <ng-container *ngIf="!!featureTags && featureTags['sf_vendor_page_3']; else comingSoonImg">
                        <img *ngIf = "!!!supplier_info['vendor_logo']" class="img-responsive noImage" src="assets/images/no_image.png" 
                            alt = "{{supplier_info['vendor_name']}}" imgType="vendors" imgSize="lg">
                    </ng-container>
                    <ng-template #comingSoonImg>
                        <span *ngIf = "!!!supplier_info['vendor_logo']" >{{supplier_info['vendor_name']}}</span>
                    </ng-template>
                </div>
                <div fxFlex="100" fxFlex.gt-xs="80" class="p-2" class="Vendor_Title">
                    <h4>{{supplier_info['vendor_name'] | titlecase}}</h4>
                        <div class="underline"></div>
                        <p *ngIf="!!featureTags && !featureTags['sf_vendor_page_2']"
                            [innerHTML]="supplier_info['vendor_description']"></p>
                        <p *ngIf="!!featureTags && featureTags['sf_vendor_page_2']" 
                            [innerHTML]="sanitizedDescription"></p>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="!!featureTags && featureTags['ftag_sf_previously_ordered_products']">
            <div *ngIf="viewType == 'grid' && pageLoaded"
                fxLayout="row wrap">
                <div *ngFor="let item of array">
                    <div class="fb-item">
                        <div class="first-section-wrapper">
                            <div class="gravatar">
                                <ngx-skeleton-loader appearance="circle"
                                    [theme]="{ width: '80px', height: '80px', 'border-radius': '10px' }">
                                </ngx-skeleton-loader>
                            </div>
                            <div class="gravatar-title">
                                <div>
                                    <ngx-skeleton-loader [theme]="{
                                    width: '200px',
                                    'border-radius': '0',
                                    height: '15px',
                                    'margin-bottom': '10px'
                                }"></ngx-skeleton-loader>
                                </div>
                                <div>
                                    <ngx-skeleton-loader
                                        [theme]="{ width: '170px', 'border-radius': '0', height: '15px' }"></ngx-skeleton-loader>
                                </div>
                            </div>
                        </div>
                        <div class="second-section-wrapper">
                            <div class="wrapper">
                                <ngx-skeleton-loader [theme]="{
                                width: '80%',
                                'border-radius': '0',
                                height: '15px',
                                'margin-bottom': '10px'
                                }"></ngx-skeleton-loader>
                            </div>
                            <div class="wrapper">
                                <ngx-skeleton-loader [theme]="{
                                width: '90%',
                                'border-radius': '0',
                                height: '15px',
                                'margin-bottom': '10px'
                                }"></ngx-skeleton-loader>
                            </div>
                            <div class="wrapper">
                                <ngx-skeleton-loader [theme]="{
                                width: '60%',
                                'border-radius': '0',
                                height: '15px',
                                'margin-bottom': '10px'
                                }"></ngx-skeleton-loader>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </ng-container>
        <ng-container *ngIf="!!featureTags && !featureTags['ftag_sf_previously_ordered_products']">
            <div *ngIf="viewType == 'grid' && products.length === 0 && subCategories.length === 0 || pageLoaded"
                fxLayout="row wrap">
                <div *ngFor="let item of array">
                    <div class="fb-item">
                        <div class="first-section-wrapper">
                            <div class="gravatar">
                                <ngx-skeleton-loader appearance="circle"
                                    [theme]="{ width: '80px', height: '80px', 'border-radius': '10px' }">
                                </ngx-skeleton-loader>
                            </div>
                            <div class="gravatar-title">
                                <div>
                                    <ngx-skeleton-loader [theme]="{
                                    width: '200px',
                                    'border-radius': '0',
                                    height: '15px',
                                    'margin-bottom': '10px'
                                }"></ngx-skeleton-loader>
                                </div>
                                <div>
                                    <ngx-skeleton-loader
                                        [theme]="{ width: '170px', 'border-radius': '0', height: '15px' }"></ngx-skeleton-loader>
                                </div>
                            </div>
                        </div>
                        <div class="second-section-wrapper">
                            <div class="wrapper">
                                <ngx-skeleton-loader [theme]="{
                                width: '80%',
                                'border-radius': '0',
                                height: '15px',
                                'margin-bottom': '10px'
                                }"></ngx-skeleton-loader>
                            </div>
                            <div class="wrapper">
                                <ngx-skeleton-loader [theme]="{
                                width: '90%',
                                'border-radius': '0',
                                height: '15px',
                                'margin-bottom': '10px'
                                }"></ngx-skeleton-loader>
                            </div>
                            <div class="wrapper">
                                <ngx-skeleton-loader [theme]="{
                                width: '60%',
                                'border-radius': '0',
                                height: '15px',
                                'margin-bottom': '10px'
                                }"></ngx-skeleton-loader>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </ng-container>
        <div fxLayout="row wrap" class="products-wrapper" *ngIf="!pageLoaded" [ngClass]="{ 'products-wrapper-mobile': isFeatureTagMoblieIssue }">
            <ng-container *ngFor="let sub of subCategories">
                <ng-container *ngIf="!!featureTags && featureTags['sf_mobile_view_issue']">
                    <div class="col section-ht sub-product-item sub-category-link text-center br-20"
                    fxFlex.sm="calc(25% - 15px)" fxFlex.gt-sm="calc(25% - 15px)">                    
                        <a [routerLink]="['/categories', params['parentCategory'], sub['category_url']]">
                            <h4 class="clr-blu">
                                <span [innerHTML]="sub['category_name']  | sanitizeHtml"> </span>&nbsp; <span
                                    class="blk-clr">({{sub['count']}})</span>
                            </h4>
                        </a>
                        <a [routerLink]="['/categories', params['parentCategory'], sub['category_url']]"
                            class="sub-image-link mx-ht">
                            <img src="data:," [imgName]="sub['category_image']" imgType="categories" class="max-ht img-fit"
                                imagePreload alt="{{sub['category_name']}}" />
                        </a>
                    </div>    
                </ng-container>
                <ng-container *ngIf="!!featureTags && !featureTags['sf_mobile_view_issue']">
                <div class="col section-ht sub-product-item sub-category-link text-center br-20"
                    fxFlex="calc(100% - 15px)" fxFlex.sm="calc(25% - 15px)" fxFlex.gt-sm="calc(25% - 15px)">
                    <!-- *ngIf="sub['products'].length > 0"> -->
                    <a [routerLink]="['/categories', params['parentCategory'], sub['category_url']]">
                        <h4 class="clr-blu">
                            <span [innerHTML]="sub['category_name']  | sanitizeHtml"> </span>&nbsp; <span
                                class="blk-clr">({{sub['count']}})</span>
                        </h4>
                    </a>
                    <a [routerLink]="['/categories', params['parentCategory'], sub['category_url']]"
                        class="sub-image-link mx-ht">
                        <img src="data:," [imgName]="sub['category_image']" imgType="categories" class="max-ht img-fit"
                            imagePreload alt="{{sub['category_name']}}" />
                    </a>
                </div>
                </ng-container>
            </ng-container>
        </div>

        <div fxLayout="row" *ngIf="(products.length > 0 || subCategories.length > 0 ) && pageLoaded === false"
            fxLayout.xs="row" fxLayoutAlign="end center" class="filter-row mat-elevation-z1 text-muted">
            <div>
                <!-- if category name is empty then show this button -->
                <!-- <button *ngIf="!sidenavOpen && !categoryName" mat-icon-button (click)="sidenav.toggle()" class="threeDot">
                    <i class="material-icons " data-icon="more_vert"></i>
                </button> -->
                <!-- end -->
                <a mat-button [matMenuTriggerFor]="sortMenu" #sortMenuTrigger="matMenuTrigger" class="sort">
                    <span *ngIf="!!selectedSorting">{{selectedSorting['display']}}</span>
                    <!-- <i class="material-icons md-18 caret" data-icon="arrow_drop_down"></i> -->
                    <mat-icon>arrow_drop_down</mat-icon>
                </a>
                <mat-menu #sortMenu="matMenu" xPosition="before" class="app-dropdown" overlapTrigger="true">
                    <!-- <span (mouseleave)="sortMenuTrigger.closeMenu()"> -->
                    <span>
                        <button mat-menu-item class="pad-left" *ngFor="let option of sortingOptions"
                            [ngStyle]="{'color': option['selected'] === true ? '#d32f2f !important': ''}"
                            (click)="changeSort($event, option)">
                            <button mat-icon-button class="left-wid">
                                <i class="material-icons md-16 " data-icon="done"
                                    *ngIf="option['selected'] === true"></i>
                                <i class="material-icons md-16 " data-icon="" *ngIf="option['selected'] === false"></i>
                            </button>
                            <span>{{option['display']}}</span>
                        </button>
                    </span>
                </mat-menu>
                <a mat-button [matMenuTriggerFor]="countsMenu" #countsMenuTrigger="matMenuTrigger" class="countsMenu">
                    Show {{count}}
                    <!-- <i class="material-icons md-18 caret" data-icon="arrow_drop_down"></i> -->
                    <mat-icon>arrow_drop_down</mat-icon>
                </a>
                <mat-menu #countsMenu="matMenu" xPosition="before" class="app-dropdown" overlapTrigger="true">
                    <span (mouseleave)="countsMenuTrigger.closeMenu()">
                        <button mat-menu-item *ngFor="let count of counts" (click)="changeCount(count)">
                            <span>{{count}}</span>
                        </button>
                    </span>
                </mat-menu>
                <button mat-icon-button (click)="changeViewType('list', 100)">
                    <i class="material-icons" data-icon="view_list"></i>
                </button>
                <button mat-icon-button (click)="changeViewType('grid', 33.3)">
                    <i class="material-icons" data-icon="view_module"></i>
                </button>
                <button mat-icon-button (click)="changeViewType('grid', 25)">
                    <i class="material-icons" data-icon="view_comfy"></i>
                </button>
                <!-- <button mat-icon-button (click)="changeViewType('list', 100)">
                    <i class="material-icons" data-icon="view_list"></i>
                </button>
                <button mat-icon-button (click)="changeViewType('grid', 33.3)" fxHide.lt-sm="true" fxShow.gt-sm="true">
                    <i class="material-icons" data-icon="view_module"></i>
                </button>
                <button mat-icon-button (click)="changeViewType('grid', 100)" fxShow.lt-sm="true" fxHide.gt-sm="true">
                    <i class="material-icons" data-icon="view_module"></i>
                </button>
                <button mat-icon-button (click)="changeViewType('grid', 50)" fxShow.lt-sm="true" fxHide.gt-sm="true">
                    <i class="material-icons" data-icon="view_comfy"></i>
                </button>
                <button mat-icon-button (click)="changeViewType('grid', 25)" fxHide.lt-sm="true" fxShow.gt-sm="true">
                    <i class="material-icons" data-icon="view_comfy"></i>
                </button> -->
            </div>
        </div>

        <div *ngIf="productNotAvailable" fxLayout="row" fxLayout.xs="row" fxLayoutAlign="space-between center"
            class="filter-row mat-elevation-z1 text-muted mt-16 mb-16 content-center">
            <div>
                *No Products found.
            </div>
        </div>
        <mat-divider></mat-divider>

        <div *ngIf="viewType === 'grid'  && products.length > 0 && !pageLoaded" fxLayout="row wrap" class="products-wrapper GridViews">
            <div *ngFor="let product of products | paginate: { id: 'server', itemsPerPage: count, currentPage: page, totalItems: totalProductsCount } ;let i= index "
                fxFlex="100" [fxFlex.gt-sm]="viewCol" [fxFlex.lt-sm]="viewColMob" class="col section-ht">
                <mat-card class="product-item text-center" 
                [ngClass]="{'product-container-item': isFeatureTagShowTwoLineDescription}"
                >
                    <div class="Probadges" [ngClass]="{ 'ProbadgeImgFit': FeatureTagProbadgeImgFit }">
                        <ul>
                            <li *ngFor="let badge of product['product']['cb_product_badges']">
                                <img [src]="badge['cb_badge']['image'] | mapUrlForImg" alt="">
                            </li>
                        </ul>
                    </div>
                    <div class="sold-out" (click)="onLinkClick($event, product)" *ngIf="!!product['product']['stock_info'] && product['product']['stock_info']['restrict_orders'] == 1 && product['product']['stock_info']['stock_in_hand']==0">
                        <img class="sold-out-img" src="assets/images/others/sold_out_icon.svg" imgType="products" ngClass.lt-md="sm" alt="sold out"/>
                    </div>
                    <mat-chip-list fxLayout="row" fxLayout.lt-sm="row" class="grid">
                        <mat-chip color="warn" class="design" selected="true"
                            *ngIf="!!product['product']['featured_product']">FEATURED</mat-chip>
                        <mat-chip class="newItem design" selected="true"
                            *ngIf="!!product['product']['new_arrival']">NEW! </mat-chip>
                    </mat-chip-list>
                    <!-- <a [routerLink]="chkCategory ? goToProduct(product, 'route'): [product['product']['cb_category']['url'],product['product']['description'],product['product']['id']]" (click)="featureTags['enable_individual_products_page'] == true ? goToProduct(product, 'parent') : product['product'] && products['storeDetailsJson']['settings']['productFullView'] === true ? goToProduct(product, 'parent') : openProductDialog(product)" 
                        class="image-link hand" > -->
                    <a [attr.href]="generateHref(product)" (click)="onLinkClick($event, product)"
                        class="image-link hand" *ngIf="!this.chkProduct">
                        <img src="data:,"
                            [imgName]="!!product['product']['product_image1'] ? product['product']['product_image1'] : product['product']['product_image2']"
                            imgType="products" imgSize="md" imagePreload alt="{{product['product']['description']}}" />
                    </a>
                    <ng-container *ngIf="featureTags && !featureTags['sf_href_link']">
                        <a (click)="onLinkClick($event, product)" class="image-link hand" *ngIf="this.chkProduct">
                            <img src="data:,"
                                [imgName]="!!product['product']['product_image1'] ? product['product']['product_image1'] : product['product']['product_image2']"
                                imgType="products" imgSize="md" imagePreload alt="{{product['product']['description']}}" />
                        </a>
                    </ng-container>
                    <ng-container *ngIf="featureTags && featureTags['sf_href_link']">
                        <a [attr.href]="generateHref(product)" (click)="onLinkClick($event, product)" class="image-link hand" *ngIf="this.chkProduct">
                            <img src="data:,"
                                [imgName]="!!product['product']['product_image1'] ? product['product']['product_image1'] : product['product']['product_image2']"
                                imgType="products" imgSize="md" imagePreload alt="{{product['product']['description']}}" />
                        </a>
                    </ng-container>
                    <!-- <a (click)="featureTags['enable_individual_products_page'] == true ? goToProduct(product, 'parent') : product['product'] && products['storeDetailsJson']['settings']['productFullView'] === true ? goToProduct(product, 'parent') : openProductDialog(product)"   class="title text-truncate hand"  [routerLink]="chkCategory ? [product['product']['description'],product['product']['id']] : [product['product']['cb_category']['url'],product['product']['description'],product['product']['id']]"> -->
                    <ng-container *ngIf="!!featureTags && featureTags['ftag_sf_show_two_line_description_in_product_card']">
                        <a [attr.href]="generateHref(product)" (click)="onLinkClick($event, product)"
                        class="hand nounderline" *ngIf="!this.chkProduct">
                            <ng-container *ngIf="!!featureTags && featureTags['ftag_sf_manufacturer_list']">
                                <h4 class="category text-muted hand" *ngIf="product['product'] && (product['product']['manufacturer_name'] || product['product']['vendor_name'])">
                                {{ product['product']['manufacturer_name'] || product['product']['vendor_name'] }}
                                </h4>
                            </ng-container>                            
                            <ng-container *ngIf="!!featureTags && !featureTags['ftag_sf_manufacturer_list']">
                                <h4 class="category text-muted hand" *ngIf="product['product'] && !!product['product']['vendor_name']">{{product['product']['vendor_name'] }}</h4>
                            </ng-container>                        
                            <span class="title text-wrap-line">{{product['product']['description']}}</span>
                        </a>
                    </ng-container>
                    <ng-container *ngIf="!!featureTags && !featureTags['ftag_sf_show_two_line_description_in_product_card']">
                        <a [attr.href]="generateHref(product)" (click)="onLinkClick($event, product)"
                            class="title text-truncate hand" *ngIf="!this.chkProduct">                            
                            <h4 class="category text-muted hand" *ngIf="product['product']">{{
                                product['product']['cb_category']['category_name'] }}</h4>
                            {{product['product']['description']}}
                        </a>
                    </ng-container>
                    <ng-container *ngIf="featureTags && !featureTags['sf_href_link']">
                        <a (click)="onLinkClick($event, product)" class="title text-truncate hand" *ngIf="this.chkProduct">
                            <h4 class="category text-muted hand" *ngIf="product['product']">{{
                                product['product']['cb_category']['category_name'] }}</h4>
                            {{product['product']['description']}}
                        </a>
                    </ng-container>
                    <ng-container *ngIf="featureTags && featureTags['sf_href_link']">
                        <ng-container *ngIf="!!featureTags && featureTags['ftag_sf_show_two_line_description_in_product_card']">
                            <a [attr.href]="generateHref(product)" (click)="onLinkClick($event, product)" class="hand nounderline" *ngIf="this.chkProduct">
                                <ng-container *ngIf="!!featureTags && featureTags['ftag_sf_manufacturer_list']">
                                    <h4 class="category text-muted hand" *ngIf="product['product'] && (product['product']['manufacturer_name'] || product['product']['vendor_name'])">
                                    {{ product['product']['manufacturer_name'] || product['product']['vendor_name'] }}
                                    </h4>
                                </ng-container>                            
                                <ng-container *ngIf="!!featureTags && !featureTags['ftag_sf_manufacturer_list']">
                                    <h4 class="category text-muted hand" *ngIf="product['product'] && !!product['product']['vendor_name']">{{product['product']['vendor_name'] }}</h4>
                                </ng-container>                          
                                <span class="title text-wrap-line">{{product['product']['description']}}</span>
                            </a>
                        </ng-container>
                        <ng-container *ngIf="!!featureTags && !featureTags['ftag_sf_show_two_line_description_in_product_card']">
                            <a [attr.href]="generateHref(product)" (click)="onLinkClick($event, product)" class="title text-truncate hand" *ngIf="this.chkProduct">                            
                                <h4 class="category text-muted hand" *ngIf="product['product']">{{
                                    product['product']['cb_category']['category_name'] }}</h4>
                                {{product['product']['description']}}
                            </a>
                        </ng-container>
                    </ng-container>
                    <div fxLayout="row" fxLayoutAlign="space-between center" class="prices hand">
                        <div class="hand" fxLayout="row"
                            [fxLayout.lt-sm]="viewColMob === 50 ||  viewColMob === '50' ? 'column' : 'row'"
                            fxLayoutAlign="center center">
                            <p *ngIf="product['product']" class="new-price hand">
                                {{storeDetails['currency']}}{{product['product'].retail_price | number: '1.2-2'}}</p>
                            <span *ngIf="!!product['product']['cb_unit_of_measurement'] && product['product']['cb_unit_of_measurement']['acronym'] === 'lbs'"
                                class="perLb">(Per lb) </span>
                            <p class=" text-muted pd-l-5 hand" [ngStyle]="setFont()"
                                *ngIf="!!product['product'].compare_price"><span
                                    class="old-price">{{storeDetails['currency']}}{{product['product'].compare_price |
                                    number : '1.2-2'}} </span> Saved ({{product['product'].savepercentage}}%)</p>
                        </div>
                        <!-- <div fxLayout="column" fxLayoutAlign="center start"></div>
                            <p class=" text-muted pd-5"><span class = "old-price">${{product['product'].retail_price | number : '1.2-2'}} </span>Saved (45%)</p>
                        </div> -->
                        <div fxLayout="column" fxLayoutAlign="center start">
                            <p class="pd-5"><span class="">{{product['product']['size']}} <span>{{
                                        !!product['product']['size'] && !!product['product']['weight'] ? '/' : ''
                                        }}</span>
                                    {{product['product']['weight']}}</span></p>
                        </div>
                    </div>
                    <div class="divider"></div>
                    <div class="icons">
                        <app-controls [store]="storeDetails" [product]="product"
                            (onOpenProductDialog)="openProductDialog(product)"></app-controls>
                    </div>
                </mat-card>
            </div>

        </div>

        <div *ngIf="viewType === 'list' && products.length > 0 && !pageLoaded" fxLayout="row wrap" class="products-wrapper">
            <div *ngFor="let product of products | paginate: { id: 'server', itemsPerPage: count, currentPage: page, totalItems: totalProductsCount  }"
                fxFlex="100" class="col">
                <mat-card class="product-item">
                    <div fxLayout="row wrap">
                        <div fxFlex="100" fxFlex.gt-xs="25" class="p-2 product-quick-image">
                            <div class="Probadges" [ngClass]="{ 'ProbadgeImgFit': FeatureTagProbadgeImgFit }">
                                <ul>
                                    <li *ngFor="let badge of product['product']['cb_product_badges']">
                                        <img [src]="badge['cb_badge']['image'] | mapUrlForImg" alt="">
                                    </li>
                                </ul>
                            </div>
                            <mat-chip-list class="list-view wid-40" fxLayoutAlign="end">
                                <mat-chip color="warn" class="design" selected="true"
                                    *ngIf="!!product['product']['featured_product']">FEATURED</mat-chip>
                                <mat-chip class="newItem design" selected="true"
                                    *ngIf="!!product['product']['new_arrival']">NEW! </mat-chip>
                            </mat-chip-list>
                            <a class="image-link hand">
                                <img src="data:," (click)="goToProduct(product, 'parent')"
                                    [imgName]="!!product['product']['product_image1'] ? product['product']['product_image1'] : product['product']['product_image2']"
                                    imgType="products" imgSize="md" imagePreload
                                    alt="{{product['product']['description']}}" />
                            </a>
                            <div class="quick-sold-out" (click)="goToProduct(product, 'parent')" *ngIf="!!product['product']['stock_info'] && product['product']['stock_info']['restrict_orders'] == 1 && product['product']['stock_info']['stock_in_hand']==0">
                                <img class="sold-out-img" src="assets/images/others/sold_out_icon.svg" imgType="products" ngClass.lt-md="sm" alt="sold out"/>
                            </div>
                        </div>
                        <div fxFlex="100" fxFlex.gt-xs="75" class="p-2">
                            <h4 (click)="goToProduct(product, 'parent')" class="category text-muted"
                                *ngIf="product['product']">{{ product['product']['cb_category']['category_name'] }}</h4>
                            <a (click)="goToProduct(product, 'parent')" class="title hand">
                                {{product['product']['description']}}
                            </a>
                            <!-- <p class="py-1 text-muted lh"  [innerHTML]="product['product']['website_description'] | sanitizeHtml"></p> -->
                            <div fxLayout="row" fxLayoutAlign="space-between center" class="prices">
                                <div fxLayout="row" fxLayoutAlign="center center">
                                    <p *ngIf="product['product']" class="new-price">
                                        {{storeDetails['currency']}}{{product['product'].retail_price | number:
                                        '1.2-2'}}</p>
                                    <span *ngIf="!!product['product']['cb_unit_of_measurement'] && product['product']['cb_unit_of_measurement']['acronym'] === 'lbs'"
                                        class="perLb">(Per lb) </span>
                                    <p class=" text-muted pd-l-5" *ngIf="!!product['product'].compare_price"><span
                                            class="old-price">{{storeDetails['currency']}}{{product['product'].compare_price
                                            | number : '1.2-2'}} </span> Saved ({{product['product'].savepercentage}}%)
                                    </p>
                                </div>
                                <div fxLayout="column" fxLayoutAlign="center start"
                                    *ngIf="!! product['product']['size'] && product['product']['weight']">
                                    <!-- <p class="pd-5"><span class="">Large / 12</span>lbs</p> -->
                                    <p class="pd-5"><span class="">{{product['product']['size']}} <span>{{
                                                !!product['product']['size'] && !!product['product']['weight'] ? '/' :
                                                '' }}</span>
                                            {{product['product']['weight']}}</span>
                                    </p>

                                </div>
                                <!-- <div fxLayout="column" fxLayoutAlign="center start">
                                    <p class=" text-muted"><span class = "old-price">${{product['product'].retail_price | number : '1.2-2'}}  </span>Saved (45%)</p>

                                </div> -->
                            </div>
                            <div class="divider"></div>
                            <div class="icons" fxLayout="row" fxLayoutAlign="start start">
                                <app-controls [store]="storeDetails" [product]="product"
                                    (onOpenProductDialog)="openProductDialog(product)"></app-controls>
                            </div>
                        </div>
                    </div>
                </mat-card>
            </div>
        </div>
        <mat-divider *ngIf="products.length > 0"></mat-divider>
        <!-- <div  *ngFor="let sub of subCategories "  > 
            <h1  *ngIf="viewType == 'grid' && sub['products'].length > 0" [innerHTML]="sub['category_name'] | sanitizeHtml" 
                class = "clr-red pd-lt" ></h1>
            <div *ngIf="viewType == 'grid'" fxLayout="row wrap" class="products-wrapper" >
                <div *ngFor="let product of sub['products'] | paginate: { id: 'server', itemsPerPage: count, currentPage: page , totalItems: sub['count']}" fxFlex="100"  [fxFlex.gt-sm]="viewCol" [fxFlex.lt-sm]="viewCol" class="col section-ht">
                    <mat-card class="product-item text-center"   >
                        <mat-chip-list *ngIf="product.discount">
                            <mat-chip color="warn" selected="true">{{product.discount}}% OFF</mat-chip>
                        </mat-chip-list>
                        <a (click)="openProductDialog(product)" class="image-link hand" >
                            <img src="data:," [imgName]="product['product']['product_image1']" imgType="products" 
                                imgSize="sm" imagePreload alt = "{{product['product']['description']}}"/>
                        </a>
                        <h4 class="category text-muted" *ngIf="product['product']">{{ product['product']['cb_category']['category_name'] }}</h4>                                                                     
                        <a *ngIf="product['product'] && storeDetailsJson['settings']['productFullView'] === true" (click) = "goToProduct(product, 'subCat')" class="title text-truncate hand">
                            {{product['product']['description']}}
                        </a>
                        <a *ngIf="product['product'] && storeDetailsJson['settings']['productFullView'] === false" (click)="openProductDialog(product)" class="title text-truncate hand">
                            {{product['product']['description']}}
                        </a>
                        <div fxLayout="row" fxLayoutAlign="space-between center" class="prices">
                            <div fxLayout="column" fxLayoutAlign="center start">
                                <p *ngIf="product['product']" class="new-price">{{storeDetails['currency']}}{{product['product'].retail_price | number: '1.2-2'}}</p>
                            </div>
                        </div>                            
                        <div class="divider mt-2"></div>
                        <div class="icons">
                            <app-controls [store] ="storeDetails" [product]="product" (onOpenProductDialog)="openProductDialog(product)"></app-controls>
                        </div>
                    </mat-card>
                </div>
            </div>
        </div>
    
        <div  *ngFor="let sub of subCategories ">
            <h1 *ngIf="viewType === 'list' && sub['products'].length > 0" 
            [innerHTML]="sub['category_name']  | sanitizeHtml" class = "clr-red pd-lt"></h1>
            <div *ngIf="viewType === 'list'" fxLayout="row wrap" class="products-wrapper">
                <div *ngFor="let product of sub['products'] | paginate: { id: 'server', itemsPerPage: count, currentPage: page , totalItems: sub['count']}"
                    fxFlex="100" class="col">
                    <mat-card class="product-item">
                        <div fxLayout="row wrap">
                            <div fxFlex="100" fxFlex.gt-xs="40" class="p-2">
                                <mat-chip-list *ngIf="product.discount" class="list-view">
                                    <mat-chip color="warn" selected="true">{{product.discount}}% OFF</mat-chip>
                                </mat-chip-list>
                                <a (click)="openProductDialog(product)" class="image-link hand">
                                    <img src="data:," [imgName]="product['product']['product_image1']" imgType="products" 
                                        imgSize="sm" imagePreload alt = "{{product['product']['description']}}"/>
                                </a>
                            </div>
                            <div fxFlex="100" fxFlex.gt-xs="60" class="p-2">
                                <h4 class="category text-muted"  *ngIf="product['product']">
                                    {{ product['product']['cb_category']['category_name'] }}
                                </h4>                                                                     
                                <a *ngIf="product['product'] && storeDetailsJson['settings']['productFullView'] === true" (click) = "goToProduct(product, 'subCat')" class="title hand">
                                    {{product['product']['description']}}
                                </a>
                                <a *ngIf="product['product'] &&  storeDetailsJson['settings']['productFullView'] === false" 
                                    (click)="openProductDialog(product)" class="title hand">
                                    {{product['product']['description']}}
                                </a>
                                <p class="py-1 text-muted lh" 
                                    [innerHTML]="product['product']['website_description'] | sanitizeHtml"></p>
                                <div fxLayout="row" fxLayoutAlign="space-between center" class="prices">
                                    <div fxLayout="column" fxLayoutAlign="center start">
                                        <p *ngIf="product['product']" class="new-price">
                                            {{storeDetails['currency']}}{{product['product'].retail_price | number: '1.2-2'}}
                                        </p>
                                    </div>
                                </div>                            
                                <div class="divider"></div>
                                <div class="icons">
                                    <app-controls [product]="product" [store] ="storeDetails" (onOpenProductDialog)="openProductDialog(product)"></app-controls>
                                </div>
                            </div>
                        </div>
                    </mat-card>
                </div>
                <mat-divider></mat-divider>
                
            </div>
        </div>  -->
        <div *ngIf="categoryWebsiteMessage">
            <div fxLayout="column">
                <div fxLayout="row" fxLayoutGap="5px" class="p-20">
                    <div [innerHTML]="categoryWebsiteMessage | sanitizeHtml"></div>
                </div>
            </div>
        </div>
        <div *ngIf="products.length > 0 || subCategories.length > 0" fxLayout="row wrap">
            <div fxFlex="100">
                <mat-card class="p-0 text-center">
                    <!-- <pagination-controls class="product-pagination" id = "server"
                     (pageChange)="onPageChanged($event)"></pagination-controls> -->
                     <ng-container *ngIf="!!featureTags && featureTags['sf_seo']; else elsePagination">
                        <pagination-template #pT="paginationApi" maxSize="5" class="product-pagination" id="server"
                        (pageChange)="p =$event ; onPageChanged($event)">
                        <div class="custom-pagination ngx-pagination">
                            <div class="pagination-previous" [class.disabled]="pT.isFirstPage()">
                                <a [class.text-muted]="pT.isFirstPage()" [routerLink]=""
                                    [queryParams]="{page: pT.isFirstPage() ? null :  (pT.getCurrent() - 1 ) === 1 ? null : pT.getCurrent() - 1 }"
                                    queryParamsHandling="merge" (click)="onPageLinkClick(pT.getCurrent() - 1)"> Previous </a>
                            </div>

                            <div *ngFor="let page of pT.pages">
                                <a [class.current]="pT.getCurrent() === page.value" [routerLink]="[]"
                                    [queryParams]="{page: page.value}" queryParamsHandling="merge"
                                    *ngIf="pT.getCurrent() !== page.value" (click)="onPageLinkClick(page.value)">
                                    <span>{{ page.label }}</span>
                                </a>
                                <div [class.current]="pT.getCurrent() === page.value"
                                    *ngIf="pT.getCurrent() === page.value" (click)="onPageLinkClick(page.value)">
                                    <span>{{ page.label }}</span>
                                </div>
                            </div>

                            <div class="pagination-next" [class.disabled]="pT.isLastPage()">
                                <a [class.text-muted]="pT.isLastPage()" [routerLink]=""
                                    [queryParams]="{page: pT.isLastPage() ? null : pT.getCurrent() + 1}"
                                    queryParamsHandling="merge" (click)="onPageLinkClick(pT.getCurrent() + 1)"> Next </a>
                            </div>
                        </div>
                    </pagination-template>
                     </ng-container>
                     <ng-template #elsePagination>
                        <pagination-template #pT="paginationApi" maxSize="5" class="product-pagination" id="server"
                        (pageChange)="p =$event ; onPageChanged($event)">
                        <div class="custom-pagination ngx-pagination">
                            <div class="pagination-previous" [class.disabled]="pT.isFirstPage()">
                                <a [class.text-muted]="pT.isFirstPage()" [routerLink]=""
                                    [queryParams]="{page: pT.isFirstPage() ? null :  (pT.getCurrent() - 1 ) === 1 ? null : pT.getCurrent() - 1 }"
                                    queryParamsHandling="merge"> Previous </a>
                            </div>

                            <div *ngFor="let page of pT.pages">
                                <a [class.current]="pT.getCurrent() === page.value" [routerLink]="[]"
                                    [queryParams]="{page: page.value}" queryParamsHandling="merge"
                                    *ngIf="pT.getCurrent() !== page.value">
                                    <span>{{ page.label }}</span>
                                </a>
                                <div [class.current]="pT.getCurrent() === page.value"
                                    *ngIf="pT.getCurrent() === page.value">
                                    <span>{{ page.label }}</span>
                                </div>
                            </div>

                            <div class="pagination-next" [class.disabled]="pT.isLastPage()">
                                <a [class.text-muted]="pT.isLastPage()" [routerLink]=""
                                    [queryParams]="{page: pT.isLastPage() ? null : pT.getCurrent() + 1}"
                                    queryParamsHandling="merge"> Next </a>
                            </div>
                        </div>
                    </pagination-template>
                     </ng-template>
                    
                </mat-card>
            </div>
        </div>

    </mat-sidenav-content>

    <mat-sidenav-content class="all-products" ngClass.gt-sm="p-left" *ngIf="router.url === '/categories'">
        <ng-container *ngIf="featureTags && featureTags['ftag_sf_previously_ordered_products']">
        <app-categories [categories]="categories" [filterCategoriesMenu]="categories"></app-categories>
        </ng-container>
        <ng-container *ngIf="featureTags && !featureTags['ftag_sf_previously_ordered_products']">
            <app-categories [categories]="categories"></app-categories>
        </ng-container>
    </mat-sidenav-content>
    <mat-sidenav-content class="all-products" ngClass.gt-sm="p-left" *ngIf="router.url === '/shop'">
        <app-home></app-home>
    </mat-sidenav-content>
</mat-sidenav-container>

<!-- <button class="shopping-cart-bar" (click) ="goToCart()">
    <span class="total-items">
        <i class="material-icons md-18 mat-icon-sm" data-icon="shopping_basket"></i>
        <span>{{shoppingCartStatusBarData.items}} Items</span>
    </span>
    <span class="total">
        {{storeDetails['currency']}}{{(shoppingCartStatusBarData.total | number: '1.2-4' | replacecomma) | number: '1.2-2'}}
    </span> 
</button> -->

<!-- Products Dialog Popup -->
<ng-template #productDialog let-data class="product-dialog">
    <div class="close-btn-outer">
        <button mat-mini-fab color="warn" (click)="close()"><i class="material-icons" data-icon="close"></i></button>
    </div>
    <div mat-dialog-content class="quick-flow">
        <div fxLayout="row wrap">
            <div fxFlex="100" fxFlex.gt-sm="30">
                <mat-chip-list>
                    <mat-chip color="warn" class="design" selected="true"
                        *ngIf="!!data['product']['featured_product']">FEATURED</mat-chip>
                    <mat-chip class="newItem design" selected="true" *ngIf="!!data['product']['new_arrival']">NEW!
                    </mat-chip>
                </mat-chip-list>
                <div class="swiper-container h-100" [swiper]="swiperConfig">
                    <div class="swiper-wrapper">
                        <div *ngFor="let image of data.images" class="swiper-slide">
                            <img src="data:," [imgName]="image.medium" imgType="products" imgSize="md"
                                class="swiper-lazy" ngClass.lt-md="sm" imagePreload
                                alt="{{data['product']['description']}}" />
                            <div class="swiper-lazy-preloader"></div>
                        </div>
                    </div>
                    <button mat-icon-button
                        class="swiper-button-prev swipe-arrow"><mat-icon>keyboard_arrow_left</mat-icon></button>
                    <button mat-icon-button
                        class="swiper-button-next swipe-arrow"><mat-icon>keyboard_arrow_right</mat-icon></button>
                </div>
            </div>
            <div fxFlex="100" fxFlex.gt-sm="70" ngClass.gt-sm="px-2 m-0" ngClass.sm="mt-2" ngClass.xs="mt-2">
                <h2>{{data['product']['description']}}</h2>
                <div class="py-1 lh">
                    <ng-container *ngIf="!!featureTags && featureTags['ftag_sf_show_two_line_description_in_product_card']">
                        <p class="category-producer">
                            <span class="categoryConaiter">
                                <span class="text-muted fw-500">Category: </span>
                                <span>{{ data['product']['cb_category']['category_name'] }}</span>
                            </span>
                            <ng-container *ngIf="!!featureTags && featureTags['ftag_sf_manufacturer_list']">
                                <span class="producerConaiter" *ngIf="!!data['product'] && (data['product']['manufacturer_name'] || data['product']['vendor_name'])">
                                    <span class="text-muted fw-500">Producer: </span>
                                    <span>{{ data['product']['manufacturer_name'] || data['product']['vendor_name'] }}</span>
                                </span>
                            </ng-container>
                            <ng-container *ngIf="!!featureTags && !featureTags['ftag_sf_manufacturer_list']">
                                <span class="producerConaiter" *ngIf="!!data['product']['vendor_name']">
                                    <span class="text-muted fw-500">Producer: </span>
                                    <span>{{ data['product']['vendor_name'] }}</span>
                                </span>
                            </ng-container>
                        </p>
                    </ng-container>
                    <ng-container *ngIf="!!featureTags && !featureTags['ftag_sf_show_two_line_description_in_product_card']">
                        <p>
                            <span class="text-muted fw-500">Category: </span>
                            <span>{{ data['product']['cb_category']['category_name'] }}</span>
                        </p>
                    </ng-container>
                </div>
                <!-- <p class="py-1 text-muted lh description"  
                    [innerHTML]="data['product']['website_description'] | sanitizeHtml"></p> -->
                <p class="py-1 text-muted lh description" id="quickViewDes">
                    <span>{{ productDescription | limitWords }}</span>
                </p>
                <!-- <div fxLayoutAlign="end center" class="text-muted" *ngIf="storeDetailsJson['settings']">                 
                    <button *ngIf="storeDetailsJson['settings']['productFullView'] === true" 
                        [mat-dialog-close]="product" mat-icon-button matTooltip="View full details">
                        <mat-icon>arrow_forward</mat-icon>
                    </button>               
                </div> -->
                <div class="divider" fxShow="false" fxShow.gt-sm="true"></div>
                <div fxLayout="row" fxLayoutAlign="space-between center" fxShow="false" fxShow.gt-sm="true"
                    class="prices mt-1">

                    <ng-container *ngIf="!!featureTags && featureTags['pdp_button_change']; else buttonChangePartOne">
                        <div class="priceRow">
                            <h2 class="mt-1 new-price">{{storeDetails['currency']}}{{data['product']['retail_price'] |
                                number: '1.2-2'}}
                            </h2>
                            <span *ngIf="!!data['product']['cb_unit_of_measurement'] && data['product']['cb_unit_of_measurement']['acronym'] === 'lbs'" 
                                class="perLb-big mt-1" style="line-height: normal;">(Per lb) </span>
                            <p class="mt-1 greyText pd-5" *ngIf="!!data['product'].compare_price"><span
                                    class="old-price">{{storeDetails['currency']}}{{data['product'].compare_price | number :
                                    '1.2-2'}} </span> <span class="savedPercentage">Saved ({{data['product'].savepercentage}}%)</span></p>
                        </div>
                        <app-controls *ngIf="data" [type]="'dialog'" [product]="data" [fullBtn]="true"
                            [store]="data['storeDetails']"></app-controls>
                    </ng-container>
                    <ng-template #buttonChangePartOne>
                        <div fxLayout="row" fxLayoutAlign="center start">
                            <h2 class="mt-1 new-price">{{storeDetails['currency']}}{{data['product']['retail_price'] |
                                number: '1.2-2'}}
                            </h2>
                            <span *ngIf="data['product']['cb_unit_of_measurement']['acronym'] === 'lbs'"
                                class="perLb-big">(Per lb) </span>
                            <p class="mt-1 text-muted pd-5" *ngIf="!!data['product'].compare_price"><span
                                    class="old-price">{{storeDetails['currency']}}{{data['product'].compare_price | number :
                                    '1.2-2'}} </span> Saved ({{data['product'].savepercentage}}%)</p>
                        </div>
                        <app-controls *ngIf="data" [type]="'dialog'" [product]="data"
                            [store]="data['storeDetails']"></app-controls>
                    </ng-template>
                </div>

            </div>
        </div>
    </div>
    <div mat-dialog-actions fxShow="false" fxShow.lt-md="true">
        <div fxFlex="100%" fxLayout="row" fxLayoutAlign="space-between center" class="prices productDialog">
            <ng-container *ngIf="!!featureTags && featureTags['pdp_button_change']; else buttonChangePartOne">
                <div fxLayout="column" fxLayoutAlign="center start">
                    <p class="mt-1 text-muted pd-5" *ngIf="!!data['product'].compare_price"><span
                            class="old-price">{{storeDetails['currency']}}{{data['product'].compare_price | number :
                            '1.2-2'}} </span> <span class="savedPercentage">Saved ({{data['product'].savepercentage}}%)</span></p>
                    <h2 class="new-price">{{storeDetails['currency']}}{{data['product']['retail_price'] | number: '1.2-2'}}
                        <span *ngIf="!!data['product']['cb_unit_of_measurement'] && data['product']['cb_unit_of_measurement']['acronym'] === 'lbs'"
                            class="perLb-big" style="line-height: normal;">(Per lb) </span>
                    </h2>
                </div>
                <div fxLayout="column" fxLayoutAlign="center start">                
                        <app-controls *ngIf="data" [type]="'dialog'" [product]="data" [fullBtn]="true"
                        [store]="data['storeDetails']"></app-controls>    
                </div>
            </ng-container>
            <ng-template #buttonChangePartOne>
                <div fxLayout="column" fxLayoutAlign="center start">
                    <p class="mt-1 text-muted pd-5" *ngIf="!!data['product'].compare_price"><span
                            class="old-price">{{storeDetails['currency']}}{{data['product'].compare_price | number :
                            '1.2-2'}} </span> Saved ({{data['product'].savepercentage}}%)</p>
                    <h2 class="new-price">{{storeDetails['currency']}}{{data['product']['retail_price'] | number: '1.2-2'}}
                        <span *ngIf="data['product']['cb_unit_of_measurement']['acronym'] === 'lbs'"
                            class="perLb-big">(Per lb) </span>
                    </h2>
                </div>
                <div fxLayout="column" fxLayoutAlign="center start">
                    <app-controls *ngIf="data" [type]="'dialog'" [product]="data"
                        [ngStyle]="{'margin-top': !!data['product'].compare_price ? '15px': ''}"
                        [store]="data['storeDetails']"></app-controls>
                </div>
            </ng-template>

        </div>
    </div>
</ng-template>